import * as yup from 'yup';
import { phoneRegExp } from './regex';

export const loginValidationSchema = yup.object().shape({
    accountName: yup.string()
        .required('Phone number is required.')
        .matches(phoneRegExp, 'Must be phone number format.'),
    password: yup.string()
        .required('Required.')
});

export const loginOtpValidationSchema = yup.object().shape({
    accountName: yup.string()
        .required('Phone number is required.')
        .matches(phoneRegExp, 'Must be phone number format.'),
    password: yup.string()
        .required('Required.')
        .min(6, 'Invalid code format.')
        .min(6, 'Invalid code format.')
});

export const verifyPhoneNumberValidationSchema = yup.object().shape({
    phoneNumber: yup.string()
        .required('Phone number is required.')
        .matches(phoneRegExp, 'Must be phone number format.'),
});

export const verifyValidationSchema = yup.object().shape({
    verificationCode: yup.string()
        .length(6, 'Please enter 6 digits.')
});

export const verifyOtpValidationSchema = yup.object().shape({
    otpCode: yup.string()
        .required('OTP code is required')
        .matches(/^\d{6}$/, 'OTP code must be exactly 6 digits.'),
});

export const resetPasswordValidationSchema = yup.object().shape({
  password: yup.string()
    .required('Password is required.'),
  confirmPassword: yup.string()
    .required('Confirm password is required.')
    .oneOf([yup.ref('password'), null], 'Passwords do not match. Please try again.'),
});

export const forgotPasswordValidationSchema = yup.object().shape({
    accountName: yup.string()
        .required('Phone number is required.')
        .matches(phoneRegExp, 'Must be phone number format.'),
    dob: yup.string()
        .required('Date of birth is required.')
        .matches(
            /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/,
            'Date of birth must be in MM/DD/YYYY format.'
        ),
});

export const verifyPatientAccountValidationRequireActivationCodeSchema = yup.object().shape({
    dOB: yup.string()
        .required('Date of birth is required.')
        .matches(
            /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/,
            'Date of birth must be in MM/DD/YYYY format.'
        ),
    activationCode: yup.string()
        .required('Activation code is required.')
});

export const verifyPatientAccountValidationNotRequireActivationCodeSchema = yup.object().shape({
    dOB: yup.string()
        .required('Date of birth is required.')
        .matches(
            /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/,
            'Date of birth must be in MM/DD/YYYY format.'
        ),
});
